module.exports = __webpack_public_path__ + "static/media/light-bulb.8e4d9cf1.png";